import React, { FC, memo, useEffect } from 'react';

type Props = {
  url: string;
};

const CanonicalDetector: FC<Props> = ({ url }) => {
  useEffect(() => {
    if (
      !url ||
      typeof window === 'undefined' ||
      window.location.host.includes('localhost')
    ) {
      return;
    }
    const currentUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
    if (url !== currentUrl) {
      window.location.href = url;
    }
  }, [url]);

  return null;
};

export default memo(CanonicalDetector);
